export const getInitials = (name: string): string => {
  const nameArr = name.split(' ')

  if (!nameArr[0]) {
    return ''
  }

  const firstNameLetter = nameArr[0].split('')[0]?.toUpperCase()
  const lastNameLetter = nameArr[nameArr.length === 2 ? 1 : nameArr.length - 1].split('')[0]?.toUpperCase()

  return firstNameLetter + lastNameLetter
}

export const getOrganizationInitials = (name: string): string => {
  const nameArr = name.split(' ')

  if (!nameArr[0]) {
    return ''
  }

  const firstNameLetter = nameArr[0].split('')[0]?.toUpperCase()
  const lastNameLetter = nameArr[nameArr.length === 2 ? 1 : nameArr.length - 1]
    .split('')
    [nameArr.length === 2 ? 0 : 1]?.toUpperCase()

  return firstNameLetter + lastNameLetter
}
